import { Plus } from "components/icons/generated";
import Box from "ds/components/Box";
import Button from "ds/components/Button";

import AiChatHistoryDropdown from "./Dropdown";
import { AiChatSession } from "../types";

type AiChatHistoryProps = {
  onNewChat: () => void;
  deleteChat: (chatId: string) => void;
  chats: AiChatSession[];
  currentChatId: string;
  loading: boolean;
  onSelectChat: (chatId: string) => void;
};

const AiChatHistory = ({
  onNewChat,
  deleteChat,
  chats,
  currentChatId,
  loading,
  onSelectChat,
}: AiChatHistoryProps) => {
  return (
    <Box align="center" gap="medium">
      <Button startIcon={Plus} variant="secondary" size="small" onPress={onNewChat}>
        New chat
      </Button>
      {chats.length > 0 && (
        <AiChatHistoryDropdown
          deleteChat={deleteChat}
          chats={chats}
          currentChatId={currentChatId}
          loading={loading}
          onSelectChat={onSelectChat}
        />
      )}
    </Box>
  );
};

export default AiChatHistory;
